import { ZSidLabel } from "src/types";

import { ZTypeDef } from "./ZAttrMeta";

// Можно было бы использовать unknown, но тогда компилятор не контролирует заполненность всех кейсов
type PossibleValue = ZSidLabel | boolean | number | string | null;

// eslint-disable-next-line consistent-return
export const createAttrDefaultValue = (type: ZTypeDef): PossibleValue => {
  // eslint-disable-next-line default-case
  switch (type.name) {
    case "array":
    case "file":
    case "list":
      return null;
    case "string":
    case "boolean":
    case "number":
    case "strOption":
      return type.defaultValue ?? null;
    case "dateTime":
      return type.defaultValue?.type === "absolute"
        ? type.defaultValue.value
        : null;
  }
};
